import {
  AssetRoutine,
  RoutineConfig,
  WorkflowRoutineState,
  getFullName,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Spacing } from '../../../styles';
import { Colors } from '../../../themes';
import { MessageComponentProps } from '../../issue/types';
import { routineMessageStyles } from './routineMessageStyles';

interface CommonRoutineMessageHeaderProps extends MessageComponentProps {
  children: React.ReactNode;
}

export const CommonRoutineMessageHeader = (
  props: CommonRoutineMessageHeaderProps
) => {
  const assetRoutine = props.message.assetRoutine!;
  const config = assetRoutine.routineVersion.config as RoutineConfig;
  const auditLog = (assetRoutine.data as WorkflowRoutineState)?.auditLog
    ?.auditLog;

  return (
    <View style={routineMessageStyles.container}>
      <MessageTitle
        config={config}
        assetRoutine={assetRoutine}
        isUpdated={!!auditLog}
      />
      <View style={[config?.uom ? styles.messageContianer : {}]}>
        {props.children}
      </View>
    </View>
  );
};

const MessageTitle = ({
  config,
  assetRoutine,
  isUpdated = false,
}: {
  config: RoutineConfig;
  assetRoutine?: AssetRoutine;
  isUpdated?: boolean;
}) => {
  const { t } = useTranslation();
  const who = assetRoutine?.createdBy;
  const name = who?.name ? getFullName(who?.name) : '';
  const rawUser = assetRoutine?.data?.userCount;
  const userValueDefined =
    rawUser !== undefined &&
    rawUser !== null &&
    !Number.isNaN(rawUser) &&
    rawUser !== 0;
  const userValue = userValueDefined
    ? Math.abs(Number(rawUser)).toString()
    : undefined;
  const userDetailValue = userValue
    ? assetRoutine?.data?.oldValue > assetRoutine?.data?.count
      ? `${t('routines.message.removed')} ${userValue} ${config?.uom}`
      : `${t('routines.message.added')} ${userValue} ${config?.uom}`
    : '';

  const rawCount = assetRoutine?.data?.count;
  const countDefined =
    rawCount !== undefined && rawCount !== null && !Number.isNaN(rawCount);
  const countDisplay = countDefined
    ? `${rawCount} ${config?.uom}`
    : `--${config?.uom ? ' ' + config.uom : ''}`;
  const messageTitle = config?.uom
    ? `${name} ${userValue ? userDetailValue : countDisplay}`
    : `${t('routines.message.messageTitle', { name: name })}`;

  if (isUpdated)
    return (
      <Text style={routineMessageStyles.messageTitle}>{`${t(
        'routines.message.messageTitleUpdated',
        { name: name }
      )}.`}</Text>
    );

  return (
    <>
      <Text style={routineMessageStyles.messageTitle}>{messageTitle}</Text>
      {!config?.uom && (
        <Text style={routineMessageStyles.questionLabel}>
          {config.routineButtonText}
        </Text>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  messageContianer: {
    marginTop: Spacing.baseMargin.base,
    backgroundColor: Colors.primaryGrayBackground,
    padding: Spacing.basePadding.base,
    borderRadius: 8,
  },
});
